export const getWordCount = (text: string): number | null | undefined => {
  const words = text.match(/\w+/g);
  return words && words.length;
};
